var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_46_13064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5474 10.9309L13.0688 0.45261C12.4657 -0.15087 11.4869 -0.15087 10.8831 0.45261L8.70714 2.62859L11.4674 5.38892C12.1089 5.17217 12.8444 5.31758 13.3557 5.8289C13.8695 6.3435 14.0139 7.08536 13.7919 7.72887L16.452 10.3892C17.0956 10.1674 17.8382 10.3109 18.3523 10.8258C19.0707 11.5439 19.0707 12.7078 18.3523 13.4264C17.6337 14.1451 16.4697 14.1451 15.7508 13.4264C15.2104 12.8855 15.0769 12.0919 15.3505 11.4262L12.8696 8.9453L12.8694 15.4739C13.0492 15.5628 13.2135 15.6803 13.3557 15.8217C14.0742 16.5398 14.0742 17.7039 13.3557 18.423C12.6371 19.1414 11.4727 19.1414 10.7551 18.423C10.0367 17.7039 10.0367 16.5399 10.7551 15.8218C10.9273 15.6496 11.1319 15.5131 11.3571 15.4205V8.83102C11.1315 8.73895 10.9268 8.60245 10.7551 8.42966C10.2108 7.88609 10.0799 7.08742 10.3588 6.41906L7.63783 3.69773L0.452813 10.8824C-0.150938 11.4864 -0.150938 12.4653 0.452813 13.0689L10.9316 23.5473C11.5349 24.1509 12.5135 24.1509 13.1175 23.5473L23.5473 13.1175C24.1509 12.5138 24.151 11.5343 23.5474 10.9309Z",
    fill: "#DE4C36"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46_13064"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGit);
export default __webpack_public_path__ + "static/media/git.1707b179b32c99bc6d5ede7cd48157a9.svg";
export { ForwardRef as ReactComponent };